var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncidentUserAcquisition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zM6.203 6.891H3.236a.226.226 0 0 0-.166.075.266.266 0 0 0-.068.182c.002.453.012.853 0 1.129 0 3.19 2.66 5.223 5.015 5.223 2.355 0 4.98-2.033 4.98-5.226-.012-.27-.004-.699 0-1.126a.266.266 0 0 0-.068-.182.226.226 0 0 0-.166-.075H9.797c-.13 0-.235.114-.235.254v1.102c0 2.713-3.125 2.709-3.125 0V7.145c0-.14-.104-.254-.234-.254zm-.469-3.389h-2.03c-.39 0-.704.342-.704.763v1.694c0 .14.105.254.234.254h2.97a.223.223 0 0 0 .166-.074.263.263 0 0 0 .068-.18V4.265c0-.421-.315-.763-.704-.763zm6.563-.002h-2.031c-.389 0-.704.341-.704.763v1.694c0 .14.105.254.235.254h2.969a.223.223 0 0 0 .165-.073A.263.263 0 0 0 13 5.96V4.263c0-.422-.315-.763-.703-.763z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentUserAcquisition);
export default __webpack_public_path__ + "static/media/incident-user-acquisition.48fedf8606198a3e096c99bff976d193.svg";
export { ForwardRef as ReactComponent };